import React, { Component } from 'react';
import './styles.css';

class DarkSectionLayout extends Component {
	render() {
		return <div className="dark-section-layout">{this.props.children}</div>;
	}
}

export default DarkSectionLayout;
